module.exports = __webpack_public_path__ + "img/bj5.cc84480f.png";